module.exports = __webpack_public_path__ + "img/icon_mega.ce31ec0a.svg";